import dynamic from 'next/dynamic'

/* Every 3D piece is loaded on the client only, after the page content */

export const BagView3D = dynamic(() => import('@/components/three/stage-views').then(loaded => loaded.BagView), { ssr: false })

export const ViewerView3D = dynamic(() => import('@/components/three/stage-views').then(loaded => loaded.ViewerView), { ssr: false })

export const MascotView3D = dynamic(() => import('@/components/three/stage-views').then(loaded => loaded.MascotView), { ssr: false })

export const HeroScene3D = dynamic(() => import('@/components/three/hero-scene'), { ssr: false })

export const PackagePreview3D = dynamic(() => import('@/components/three/package-preview'), { ssr: false })
